import { all, call, put, takeLatest } from "redux-saga/effects";
import { msalInstance } from "../App";
import { loginFormId } from "../components/dialog/LoginDialog/LoginDialog";
import { onSystemInitializeAssignPage } from "../pages/assign/assign-page.saga";
import { appActions } from "../store/app.store";
import { systemActions } from "../store/system.store";
import { uiActions } from "../store/ui.store";
import { Employee } from "../types/types";
import { constants } from "../util/constants";
import { acquireAccessToken } from "../util/msal";
import { onSystemFetchAllAssigns } from "./assigns.saga";
import { onSystemFetchAllEmployees } from "./employees.saga";
import { onSystemFetchAllGroups } from "./groups.saga";
import { onSystemFetchAllJobs } from "./jobs.saga";

/**
 * システムがアプリケーションを初期化する
 */
export function* onSystemInitializeApplication() {
  // const user = localStorage.getItem(constants.STORAGE_KEY_USER);

  // if (!user) {
  //   yield put(
  //     uiActions.SYSTEM_OPEN_DIALOG({
  //       title: "Login to Flowless",
  //       type: "LOGIN",
  //       isModal: true
  //     })
  //   );
  //   return;
  // }

  // yield put(uiActions.SYSTEM_CLOSE_DIALOG({ formId: loginFormId }));

  try {
    yield put(uiActions.REDUCER_LOADING_STARTED());

    // TODO: 呼び出し順に依存しないようにする
    yield all([
      yield call(onSystemFetchAllGroups),
      yield call(onSystemFetchAllEmployees),
      yield call(onSystemFetchAllJobs),
      yield call(onSystemFetchAllAssigns),
    ]);

    yield call(onSystemInitializeAssignPage);
  } finally {
    yield put(uiActions.REDUCER_LOADING_STOPPED());
  }
}

/**
 * システムSaga
 */
export function* systemSagas() {
  yield all([
    yield takeLatest(
      systemActions.SYSTEM_INITIALIZE_APPLICATION,
      onSystemInitializeApplication
    ),
  ]);
}
